import { IIcon } from 'common/src/designSystem/components/i';
import { EventId, OrganizationId } from 'common/src/generated/types';
import { TranslateFn } from 'common/src/services/translationService';
import { CampaignsPaths } from 'common/src/util/paths/campaignsPaths';
import { HeaventPaths } from 'common/src/util/paths/heaventPaths';
import { WorkflowsPaths } from 'common/src/util/paths/workflowsPaths';

export type OmnibarAction = {
    icon: IIcon;
    text: string;
    link: string;
};

export function getOmnibarOrganizationActions(
    translate: TranslateFn,
    organizationId: OrganizationId
): OmnibarAction[] {
    return [
        /* TODO {
        icon : 'user',
        text : translate('cr_er_un_membre_38547'),
        link :
    }, */
        {
            icon: 'cake-candles',
            text: translate('cr_er_un_v_nem_28126'),
            link: HeaventPaths.CREATE_EVENT(organizationId)
        },
        /* TODO {
            icon: 'text',
            text: translate('cr_eer_un_champ_08883'),
            link: HeaventPaths.CREATE_CUSTOM_FIELD(organizationId)
        },*/
        {
            icon: 'users',
            text: translate('cr_er_une_d_l_g_23035'),
            link: HeaventPaths.COMMUNITY_CREATE_DELEGATION(organizationId)
        },
        {
            icon: 'paper-plane',
            text: translate('cr_er_une_campa_96023'),
            link: CampaignsPaths.CREATE({ organizationId })
        }
    ];
}

export function getOmnibarEventActions(
    translate: TranslateFn,
    organizationId: OrganizationId,
    eventId: EventId
): OmnibarAction[] {
    return [
        /* TODO {
        icon : 'user',
        text : translate('cr_er_un_membre_38547'),
        link :
    }, */ {
            icon: 'cake-candles',
            text: translate('cr_er_un_v_nem_28126'),
            link: HeaventPaths.CREATE_EVENT(organizationId)
        },
        {
            icon: 'sitemap',
            text: translate('cr_er_une_missi_66818'),
            link: HeaventPaths.CREATE_POSITION(organizationId, eventId)
        },
        /* TODO {
        icon : 'file-lines',
        text:translate('cr_er_un_formul_78352'),
        link: HeaventPaths.form
    },*/ {
            icon: 'badge-check',
            text: translate('cr_er_une_accr_33475'),
            link: HeaventPaths.CREATE_ACCREDITATION(organizationId, eventId)
        },
        {
            icon: 'users',
            text: translate('cr_er_une_d_l_g_23035'),
            link: HeaventPaths.CREATE_DELEGATION(organizationId, eventId)
        },
        {
            icon: 'paper-plane',
            text: translate('cr_er_une_campa_96023'),
            link: CampaignsPaths.CREATE({ organizationId, eventId })
        },
        {
            icon: 'hand-sparkles',
            text: translate('cr_er_une_autom_91246'),
            link: WorkflowsPaths.CREATE({ organizationId, eventId })
        } /* TODO, {
        icon: 'wand-magic-sparkles',
        text: translate('affecter_un_mem_09798'),
        link: HeaventPaths.assign
    },{
        icon: 'badge-check',
        text: translate('accr_diter_un_m_50869'),
        link: ''
    }*/
    ];
}
